import { createContext, useContext } from "react";
export const ParameterDeclarationContext = createContext(void 0);
export const ParameterDeclarationProvider = ParameterDeclarationContext.Provider;
export const useParameterDeclarationContext = () => useContext(ParameterDeclarationContext);
